import { useUserState } from '../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { gradients } from '@juvare/common-web-ui/ColorPaper';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useAttachmentClient } from '@juvare/platform-sdk-react/ui/hooks';
import { getImageDataUrl } from '@juvare/platform-sdk-react/ui/utils';
import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import avatarPlaceholder from '../../../../assets/avatarPlaceholder.svg';
export const AccountAvatar = ({ size }) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const [imageDataUrl, setImageDataUrl] = React.useState();
    const attachmentClient = useAttachmentClient();
    React.useEffect(() => {
        attachmentClient
            .list({ entity: 'account', entityId: userState.id })
            .then((response) => {
            const foundUserProfilePicture = response.find((attachment) => attachment.key === 'userProfilePicture');
            if (foundUserProfilePicture) {
                getImageDataUrl(attachmentClient, 'account', userState.id, 'userProfilePicture')
                    .then(setImageDataUrl)
                    .catch(handleErrorSnackbar);
            }
            else {
                setImageDataUrl(undefined);
            }
        })
            .catch(handleErrorSnackbar);
    }, [attachmentClient, userState.id]);
    if (userState) {
        const sizeInPixels = size === 'small' ? 40 : 64;
        const sx = {
            width: sizeInPixels,
            height: sizeInPixels,
            backgroundColor: gradients['blue-light-angle'],
        };
        if (userState.avatarPictureExists) {
            return React.createElement(Avatar, { sx: sx, src: imageDataUrl, "data-test": 'account-avatar' });
        }
        else {
            if (sizeInPixels === 64) {
                return (React.createElement(Box, { sx: { position: 'relative' } },
                    React.createElement(Avatar, { sx: sx, "data-test": 'account-avatar', src: avatarPlaceholder, alt: t('common.avatarPlaceholderAlt') }),
                    React.createElement(Typography, { color: 'white', variant: 'h6', sx: { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } }, userState.avatarName)));
            }
            else {
                return (React.createElement(Avatar, { sx: sx, "data-test": 'account-avatar' },
                    React.createElement(Typography, { variant: 'h6' }, userState.avatarName)));
            }
        }
    }
    else {
        return null;
    }
};
